import { render, staticRenderFns } from "./pie-charts.vue?vue&type=template&id=a370836a&"
import script from "./pie-charts.vue?vue&type=script&lang=js&"
export * from "./pie-charts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports